//
// EsriMapProvider.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../../moduleBuilder";
import EventDispatcher from "../../../events/EventDispatcher";
import "../../../lib";
import "./MapLayerProvider";

var EsriMapProvider = createModule("commons::EsriMapProvider", ["commons::PropertyOwner","commons::BaseModel","commons::AbstractMapProvider","commons::MapLayerProvider"], EventDispatcher, [
    ,
    {
        authenticationRequired: 2,
        service: 7,
        URL: 7,
        token: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default EsriMapProvider;
